import React, { useEffect, useState, useRef } from 'react';
import {useNavigate, useParams } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import PropertyService from '../../services/PropertyService';

function EditProperty() {
  const { id } = useParams();
  const toast = useRef(null);

  const [form, setForm] = useState({
    propertyName: "",
    ownerName: "",
    streetAddress: "",
    city: "",
    state: "",
    country: "",
    postalCode: "",
    price:"",
    size:"",
    description: "",
    propertyType:"",
    yearBuilt:"",
    bedrooms:"",
    bathrooms:"",
    isActive: false,
    id: id,
    clientId: "",
  });
  const [formError, setFormError] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPropertyData = async () => {
      try {
        const property = await PropertyService.getPropertyById(id);
        setForm(property);
      } catch (error) {
        console.error('Error fetching property details:', error);
      }
    };
    fetchPropertyData();
  }, [id]);

  const changeHandler = (e) => {
    const { name, value, files, type, checked } = e.target;
    if (type === 'checkbox') {
      setForm(prevForm => ({ ...prevForm, [name]: checked }));
    } else if (files) {
      setForm(prevForm => ({ ...prevForm, [name]: files[0] }));
    } else {
      setForm(prevForm => ({ ...prevForm, [name]: value }));
    }
  };

  const validateForm = () => {
    const errors = {};
    Object.keys(form).forEach(key => {
      const value = String(form[key]);
      if (!value.trim() && key !== 'userImage') {
        errors[key] = `Please enter ${key}`;
      }
    });
    setFormError(errors);
    return Object.keys(errors).length === 0;
  };

  const updateContractor = async () => {
    debugger
    const isValid = validateForm();
    if (!isValid) return;
    
    const formDataToSend = new FormData();
    
    Object.keys(form).forEach(key => {
      if (key === 'userImage' && form[key] instanceof File) {
        formDataToSend.append(key, form[key]);
      } else {
        formDataToSend.append(key, form[key]);
      }
    });
  
    try {
      await PropertyService.updateProperty(id, formDataToSend);

      if (toast.current) {
        toast.current.show({
          severity: 'success',
          summary: 'Success',
          detail: 'Contractor updated successfully',
          className: 'custom-toast-success',
          life: 3000
        });
      }
      setTimeout(() => {
        navigate(-1); // Navigate after toast shows
      }, 1000);
    } catch (error) {
      console.error("Error updating Contractor:", error);
      if (toast.current) {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to update user',
          className: 'custom-toast-delete',
          life: 3000
        });

      }
    }
  };
  
  return (
    <div>

      <Toast ref={toast} />
      <div className='form-group row'>
         <div className='col-lg-12 float-end'>
                              <div className='col-lg-3 float-end'>
                              </div> 
                   </div>
      </div>
      <br></br>

        <form onSubmit={e => e.preventDefault()}>

         
        <div className="form-group row">
          <label className="col-lg-2" htmlFor="propertyName">
            Property Name
            </label>
            <div className="col-lg-4">
          <input
            type="text"
            name="propertyName"
            id="propertyName"
            className="form-control"
            value={form.propertyName}
            onChange={changeHandler} 
          />
          <p className="text-danger">{formError.propertyName}</p>
          </div>
          <label  className="col-lg-2" htmlFor="ownerName">Owner Name</label>

          <div className="col-lg-3">
          <input
            type="text"
            name="ownerName"
            id="ownerName"
            className="form-control"
            value={form.ownerName}
            onChange={changeHandler}
          />
          <p className="text-danger">{formError.ownerName}</p>
        </div>
       
        </div>

        <div className="form-group row">
        <label className="col-lg-2" htmlFor="streetAddress">
           Street Address
            </label>
            <div className="col-lg-4">
          <input
            type="text"
            name="streetAddress"
            id="streetAddress"
            className="form-control"
            value={form.streetAddress}
            onChange={changeHandler} 
          />
          <p className="text-danger">{formError.streetAddress}</p>
          </div>

          <label  className="col-lg-2" htmlFor="city">City</label>

<div className="col-lg-3">
<input
  type="text"
  name="city"
  id="city"
  className="form-control"
  value={form.city}
  onChange={changeHandler}
/>
<p className="text-danger">{formError.city}</p>
        </div>
        </div>

        <div className="form-group row">
        <label className="col-lg-2" htmlFor="state">
          State
            </label>
            <div className="col-lg-4">
          <input
            type="text"
            name="state"
            id="state"
            className="form-control"
            value={form.state}
            onChange={changeHandler} 
          />
          <p className="text-danger">{formError.state}</p>
          </div>

          <label className="col-lg-2" htmlFor="country">Country</label>
          <div className="col-lg-3">
          <input
            type="text"
            name="country"
            id="country"
            className="form-control"
            value={form.country}
            onChange={changeHandler}
          />
          <p className="text-danger">{formError.country}</p>
        </div>
        </div>

        <div className="form-group row">
        <label className="col-lg-2" htmlFor="postalCode">Postal Code</label>
          <div className="col-lg-4">
          <input
            type="number"
            name="postalCode"
            id="postalCode"
            className="form-control"
            value={form.postalCode}
            onChange={changeHandler}
          />
          <p className="text-danger">{formError.postalCode}</p>
        </div>
 
          <label className="col-lg-2" htmlFor="price">Price</label>
          <div className="col-lg-3">
          <input
            type="number"
            name="price"
            id="price"
            className="form-control"
            value={form.price}
            onChange={changeHandler}
          />
          <p className="text-danger">{formError.price}</p>
        </div> 
        </div>
        <div className="form-group row">
        <label className="col-lg-2" htmlFor="size">Size</label>
        <div className="col-lg-4">
          <input
            type="number"
            name="size"
            id="size"
            className="form-control"
            value={form.size}
            onChange={changeHandler}
          />
          <p className="text-danger">{formError.size}</p>
          </div>
      
          <label className="col-lg-2" htmlFor="description">Description</label>
          <div className="col-lg-3">
          <input
            type="text"
            name="description"
            id="description"
            className="form-control"
            value={form.description}
            onChange={changeHandler}
          />
          <p className="text-danger">{formError.description}</p>
        </div> </div>

        <div className="form-group row">
        <label className="col-lg-2" htmlFor="propertyType">Property Type</label>
        <div className="col-lg-4">
          <input
            type="text"
            name="propertyType"
            id="propertyType"
            className="form-control"
            value={form.propertyType}
            onChange={changeHandler}
          />
          <p className="text-danger">{formError.propertyType}</p>
          </div>
       
          <label className="col-lg-2" htmlFor="yearBuilt">Year Built</label>
          <div className="col-lg-3">
          <input
            type="number"
            name="yearBuilt"
            id="yearBuilt"
            className="form-control"
            value={form.yearBuilt}
            onChange={changeHandler}
          />
          <p className="text-danger">{formError.yearBuilt}</p>
        </div>
        </div>

        <div className="form-group row">
        <label className="col-lg-2" htmlFor="bedrooms">Bed Rooms</label>
        <div className="col-lg-4">
          <input
            type="number"
            name="bedrooms"
            id="bedrooms"
            className="form-control"
            value={form.bedrooms}
            onChange={changeHandler}
          />
          <p className="text-danger">{formError.bedrooms}</p>
          </div>
       
          <label className="col-lg-2" htmlFor="bathrooms">Bath Rooms</label>
          <div className="col-lg-3">
          <input
            type="number"
            name="bathrooms"
            id="bathrooms"
            className="form-control"
            value={form.bathrooms}
            onChange={changeHandler}
          />
          <p className="text-danger">{formError.bathrooms}</p>
        </div>
        </div>
          <div className="form-group row">
            <div className="col-md-12 text-center">
              <button type="submit" className="btn btn-save btn-dark text-white" onClick={updateContractor}>Update</button>
            </div>
          </div>
        </form>
     
    </div>
  );
}

export default EditProperty;
